import React from 'react'
import "../assets/css/styles.css";



function Header() {
    return (
        <header className="masthead" id='page-top'>
        <div className="container">
          <div className="masthead-subheading ">Multipurpose <br/> Display Monitoring Unit <br/> for Scheduled Inspection <br/> on </div>
      <div className=" masthead-heading text-uppercase">AIRCRAFTS</div>
      
            <a className="btn btn-primary btn-xl text-uppercase js-scroll-trigger" href="#inspection">INSPECT</a>
        </div>
    </header>
    )
}

export default Header
